import React from "react";
import { GraduationCap, CheckCircle2 } from "lucide-react";
import { C, Pill } from "./shared";

const AUDIENCE = [
  ["College Students", "First, second or third year — start early, get ahead."],
  ["Final Year Students", "Land your first job before campus placement."],
  ["Fresh Graduates", "Bridge skill gaps and break into the workforce."],
  ["Internship Seekers", "Discover paid internships matched to your skills."],
];

const GOALS = [
  "Create your SkillConnect profile",
  "Upload skills & certificates",
  "Discover internships / jobs",
  "Improve employability score",
  "Connect with recruiters",
  "Apply to placement drives",
];

export default function AudienceGoalsSection() {
  return (
    <section className="border-y" style={{ background: C.paper, borderColor: C.rule }}>
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-20 grid lg:grid-cols-2 gap-10">
        <div>
          <Pill color={C.navy}>Who is this for?</Pill>
          <h2 className="font-display font-black text-3xl md:text-4xl mt-3 tracking-tight" style={{ color: C.navyDeep }}>
            If you&apos;re a student in India, this is for you.
          </h2>
          <div className="mt-6 space-y-3">
            {AUDIENCE.map(([t, s], i) => (
              <div key={t} className="flex items-start gap-3 p-4 rounded-xl bg-white border transition-all hover:-translate-y-0.5 hover:shadow-md"
                style={{ borderColor: C.rule }} data-testid={`audience-${i}`}>
                <span className="w-9 h-9 shrink-0 rounded-lg grid place-items-center"
                  style={{ background: `${C.green}15`, color: C.green }}>
                  <GraduationCap size={18} />
                </span>
                <div>
                  <div className="font-bold text-sm" style={{ color: C.ink }}>{t}</div>
                  <div className="text-xs text-slate-600 mt-0.5">{s}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <Pill color={C.green}>What you&apos;ll do</Pill>
          <h2 className="font-display font-black text-3xl md:text-4xl mt-3 tracking-tight" style={{ color: C.navyDeep }}>
            Six things that change your trajectory.
          </h2>
          <ul className="mt-6 grid sm:grid-cols-2 gap-3">
            {GOALS.map((g, i) => (
              <li key={g} className="flex items-center gap-3 p-4 rounded-xl bg-white border transition-all hover:-translate-y-0.5 hover:shadow-md"
                style={{ borderColor: C.rule }} data-testid={`goal-${i}`}>
                <span className="w-7 h-7 shrink-0 rounded-full grid place-items-center"
                  style={{ background: `${C.green}20`, color: C.green }}>
                  <CheckCircle2 size={14} />
                </span>
                <span className="text-sm font-medium" style={{ color: C.ink }}>{g}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
